var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAllowed('TICKETS', 'CREATE'))?_c('div',[_c('SelectedBookingView',{attrs:{"create_ticket":true},on:{"selectedSeatsAndAccomodation":_vm.handleGetSelectedSeatsAndAccommodation}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }